import React, { Fragment, useState, useEffect } from 'react';

function createWithModals(modals) {
  return function withModal(WrappedComponent) {
    return function Modal(props) {
      const [modalBoiler, setModalBoiler] = useState({});
      const [modalProps, setModalProps] = useState({});

      const onShow = (modal, modalData) => {
        setModalBoiler({
          [modal]: {
            isOpen: true,
            initial: true,
            data: modalData || {},
          },
        });
      };

      const onHide = (modal) => {
        setModalBoiler({
          [modal]: {
            isOpen: false,
            initial: true,
            data: {},
          },
        });
      };

      useEffect(() => {
        const _modalBoiler = Object.keys(modals).reduce((acc, cur) => {
          return {
            ...acc,
            [cur]: {
              isOpen: false,
              initial: false,
              data: {},
            },
          };
        }, {});

        setModalBoiler(_modalBoiler);
      }, []);

      useEffect(() => {
        const _modalProps = Object.keys(modals).reduce((acc, cur) => {
          return {
            ...acc,
            [cur]: {
              show: (data) => onShow(cur, data),
              hide: () => onHide(cur),
              state: modalBoiler[cur],
            },
          };
        }, {});

        setModalProps(_modalProps);
      }, []);

      return (
        <Fragment>
          <WrappedComponent {...props} modals={modalProps}/>
          {Object.keys(modals).map((modal) => {
            if (modalBoiler[modal] && modalBoiler[modal].initial) {
              return React.createElement(modals[modal], {
                ...modalBoiler[modal].data,
                key: [modal],
                isOpen: modalBoiler[modal].isOpen,
                onClose: () => onHide(modal),
              });
            }

            return null;
          })}
        </Fragment>
      );
    };
  };
}

export default createWithModals;
